import React, { useEffect, useState } from "react";
import {
 fetchAllPayments,
 fetchPaymentSummary,
} from "../../services/paymentService";

import PaymentTable from "./PaymentTable";
import "./paymentDashboard.css";


const PaymentDashboard = () => {

 const [payments, setPayments] = useState([]);
 const [summary, setSummary] = useState({});
 const [loading, setLoading] = useState(true);


 useEffect(() => {



 loadPayments();
 loadSummary();

 }, []);

 const loadPayments = async () => {

 try {



 const res = await fetchAllPayments();





 if (res.data && Array.isArray(res.data.content)) {

 setPayments(res.data.content);

 } else {



 setPayments([]);

 }

 } catch (err) {



 } finally {

 setLoading(false);



 }
 };

 const loadSummary = async () => {

 try {



 const res = await fetchPaymentSummary();





 setSummary(res.data);



 } catch (err) {



 }
 };

 if (loading) {



 return <div className="loading">Loading payments...</div>;

 }



 return (

 <div className="payment-dashboard">

 <h2>Payment Dashboard</h2>

 <div className="summary-container">

 <div className="summary-card">
 <div className="summary-title">Total Revenue</div>
 <div className="summary-value">
 ₹{(summary.totalRevenue/ 100) || 0}
 </div>
 </div>

 <div className="summary-card">
 <div className="summary-title">Total Payments</div>
 <div className="summary-value">
 {summary.totalPayments || 0}
 </div>
 </div>

 <div className="summary-card success">
 <div className="summary-title">Successful</div>
 <div className="summary-value">
 {summary.successfulPayments || 0}
 </div>
 </div>

 <div className="summary-card failed">
 <div className="summary-title">Failed</div>
 <div className="summary-value">
 {summary.failedPayments || 0}
 </div>
 </div>

 </div>

 <PaymentTable payments={payments} />

 </div>

 );

};

export default PaymentDashboard;
